module.exports = __webpack_public_path__ + "static/nsccsa_thumbnail-bacec015089c2f8635c274e787bacacb.jpg";